import common from './zh-TW/common';
import formatter from './zh-TW/formatter';

export default {
  ...common,
  ...formatter,
};
